import { validateAuth, AuthStatusEnum } from 'features/auth/utils';

const noopCleverTap = {
  event: { push: () => {} },
  onUserLogin: { push: () => {} },
  profile: { push: () => {} },
};

/**
 * Returns the current CleverTap instance. If `window.clevertap` is not defined
 * or the user is fully unauthenticated, returns a fallback object with empty push methods.
 * @returns { { event: { push: (eventName: string, eventProperties: object) => void }, onUserLogin: { push: (userDetails: object) => void }, profile: { push: (profileData: object) => void } } }
 */
export default function getCleverTap() {
  if (typeof window === 'undefined' || !window.clevertap) {
    return noopCleverTap;
  }

  if (validateAuth() === AuthStatusEnum.FULLY_UNAUTHENTICATED) {
    return noopCleverTap;
  }

  return window.clevertap;
}
